import React from "react";
import "../styles/LinkedIn.css";
import FadeInSection from "./FadeInSection";

class LinkedInFeed extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
//   <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7396998431539384320?collapsed=1" height="648" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
/* <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7388992026765271041?collapsed=1" height="689" width="504" frameborder="0" allowfullscreen="" title="Embedded post"></iframe> */
  render() {
    const posts = [
      "urn:li:ugcPost:7396998431539384320?collapsed=1",
      "urn:li:share:7388992026765271041?collapsed=1",
      "urn:li:ugcPost:7393716508138364928?collapsed=1",
    ];

    return (
      <div id="linkedin-feed">
        <FadeInSection>
          <div className="section-header">
            <span className="section-title">featured activity</span>
          </div>
          <div className="linkedin-posts-container">
            {posts.map((postId) => (
              <div key={postId} className="linkedin-post-wrapper">
                <iframe
                  src={`https://www.linkedin.com/embed/feed/update/${postId}`}
                  height="874"
                  width="504"
                  frameBorder="0"
                  allowFullScreen=""
                  title="LinkedIn post"
                ></iframe>
              </div>
            ))}
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default LinkedInFeed;